module.exports = __webpack_public_path__ + "static/media/Santa Clara Street, Brisbane, CA4.70d68495.jpg";